import Vue from 'vue';
import { createPinia, PiniaVuePlugin } from 'pinia';
import VueCompositionAPI from '@vue/composition-api';
import './bootstrap';
import VueMultiSelect from "./Modules/Common/VueMultiSelect.vue";
import './plugins';
import VueTheMask from 'vue-the-mask'
import VueMask from 'v-mask'
import SwalMessages from "./mixins/SwalMessages";
import dispatchState from "./mixins/dispatch-state";
import ModalHandler from "./mixins/ModalHandler";
import DateHandler from "./mixins/DateHandler";


Vue.use(VueCompositionAPI);
Vue.use(PiniaVuePlugin)
Vue.use(VueTheMask)
Vue.use(VueMask);

const mixins = [
    SwalMessages,
    dispatchState,
    ModalHandler,
    DateHandler
];
mixins.forEach(mixin => Vue.mixin(mixin));

const pinia = createPinia()

Vue.component('VueMultiSelect', VueMultiSelect );


const files = require.context('./', true, /\.vue$/i);
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

const modulesFiles = require.context('../../resources/js/Modules/', true, /\.vue$/i);
modulesFiles.keys().map(key => {
    Vue.component(key.split('/').pop().split('.')[0], modulesFiles(key).default)
});

const app = new Vue({
    el: '#app',
    pinia,
});
